"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("../classnames"));
var Spinner_1 = __importDefault(require("./Spinner"));
var Loader = /** @class */ (function (_super) {
    __extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.componentIsMounted = false;
        _this.timeout = null;
        _this.state = { spinning: false };
        _this.handleSpinnerTriggered = function () {
            var loading = _this.props.loading;
            if (_this.componentIsMounted && loading) {
                _this.setState({ spinning: true });
            }
            _this.timeout = null;
        };
        return _this;
    }
    Loader.prototype.componentDidMount = function () {
        var loading = this.props.loading;
        this.componentIsMounted = true;
        if (loading) {
            this.timeout = window.setTimeout(this.handleSpinnerTriggered, 250);
        }
    };
    Loader.prototype.componentWillUnmount = function () {
        this.componentIsMounted = false;
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    };
    Loader.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, loading = _a.loading;
        var spinning = this.state.spinning;
        if (!loading) {
            return react_1.default.createElement(react_1.default.Fragment, null, children);
        }
        return (react_1.default.createElement("div", { className: classnames_1.default("chq-ldr", className) },
            react_1.default.createElement(Spinner_1.default, { "aria-hidden": !spinning })));
    };
    return Loader;
}(react_1.default.Component));
exports.default = Loader;
